import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import ConfigAPI from '@/config/api'
import Session from '@/handler/session'

Vue.use(VueAxios, axios)

const instance = axios.create();

const servicesAPI = { 
  obtenerEmpresas() {
    var url = ConfigAPI.baseURL + "accounting-business" + Session.getToken();
    return instance.get(url);
  },     
  mostrarEmpresa(id) {
    var url = ConfigAPI.baseURL + "accounting-business/" + id + Session.getToken();
    return instance.get(url);
  },    
  agregarEmpresa(data, image1) {   
    var headers = {
      'Content-Type': 'multipart/form-data'
    }

    var formData = new FormData();
    data = JSON.parse(data)
    for ( var key in  data) {
      if(key!="image") {
        formData.append(key, data[key]);
      }

      if(key=="image") {
        var i = 0
        image1.forEach((value, key) => {
          formData.append('image_' + i, value);
          i++
        })
        formData.append('image', i);
      }
    }

    var params = formData

    var url = ConfigAPI.baseURL + "accounting-business" + Session.getToken();
    return instance.post(url,params,{headers});
  },  
  editarEmpresa(data, image1) {
    var headers = {
      'Content-Type': 'multipart/form-data'
    }

    var formData = new FormData();
    data = JSON.parse(data)
    for ( var key in  data) {
      if(key!="image") {
        formData.append(key, data[key]);
      }

      if(key=="image") {
        var i = 0
        image1.forEach((value, key) => {
          formData.append('image_' + i, value);
          i++
        })
        formData.append('image', i);
      }
    }

    var params = formData
    
    var url = ConfigAPI.baseURL + "accounting-business/" + data.id + Session.getToken();
    return instance.post(url,params,{headers});
  },
  eliminarEmpresa(id) {
    var url = ConfigAPI.baseURL + "accounting-business/"+ id + Session.getToken();
    return instance.delete(url);
  },

}

export default servicesAPI;